export default __webpack_public_path__ + "static/media/3.cacf4a61.jpg";